import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DesenharPropriedadePageRoutingModule } from './desenhar-propriedade-routing.module';

import { DesenharPropriedadePage } from './desenhar-propriedade.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DesenharPropriedadePageRoutingModule
  ],
  declarations: [DesenharPropriedadePage]
})
export class DesenharPropriedadePageModule {}
